import React from "react";
import { graphql } from "gatsby";

import Link from "../../components/Link";

import Layout from "../../components/Layout";
import WithI18next from "../../components/WithI18next";
import { isShowSupportCategory } from "../../utils";

const SupportPage = ({ data, t, lang }) => {
  return (
    <Layout
      title={t("support.seo.title")}
      description={t("support.seo.description")}
    >
      <div className="pt-5">
        <div className="container py-5 page-content">
          <div className="text-center">
            <h1 className="mb-5">{t("support.title")}</h1>
            <ol className="sc-recommended list-inline mb-5">
              <li className="list-inline-item heading">
                {t("support.startWithQuestion")}
              </li>
              {data.recommended.edges.map((post, i) => (
                <li
                  className="list-inline-item px-2"
                  key={`recommended-question-${post.node.slug}-${i}`}
                >
                  <Link
                    to={`/support/${post.node.categories.nodes[0].slug}/${post.node.slug}/`}
                  >
                    {post.node.title}
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="row">
            {data.categories.edges.map(
              (
                {
                  node: {
                    slug,
                    name,
                    description,
                    acfCategories: { catCategoryIcon, catShowOnCountries },
                  },
                },
                i
              ) =>
                isShowSupportCategory(catShowOnCountries, lang) && (
                  <div
                    className="col-lg-3 mb-3 d-flex align-items-stretch flex-fill"
                    key={`support-item-${i}`}
                  >
                    <div className="card p-4 mb-3">
                      <div className="card-body text-center">
                        <Link to={`/support/${slug}/`}>
                          <img
                            className="location-icon"
                            src={catCategoryIcon.localFile.publicURL}
                            alt={name}
                          />
                          <h5
                            className="mt-3"
                            dangerouslySetInnerHTML={{ __html: name }}
                          />
                          {description && (
                            <div
                              className="support__category-description"
                              dangerouslySetInnerHTML={{ __html: description }}
                            />
                          )}
                        </Link>
                      </div>
                    </div>
                  </div>
                )
            )}
          </div>
        </div>

        {/* acf: support_page start */}
        {data.supportPage.edges.map((post, i) => (
          <div
            id={post.node.slug}
            className="support"
            key={`support-page-${i}`}
          >
            <div className="container py-5">
              <div dangerouslySetInnerHTML={{ __html: post.node.content }} />
            </div>
          </div>
        ))}
        {/* acf: support_page end */}
      </div>
      <div className="cta mt-auto">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <h2 className="mb-4">{t("support.haveMoreQuestion")}</h2>
              <Link
                role="button"
                to={"/contact-us/"}
                className="btn btn-primary mb-2"
              >
                {t("support.btnContactUs")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WithI18next()(SupportPage);

export const query = graphql`
  query ($wpLocale: String!, $wpGlobalConfig: String!) {
    supportPage: allWpComponentItem(
      filter: {
        acfComponents: { cApplySection: { eq: "support_page" } }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpGlobalConfig } }
      }
      sort: { order: ASC, fields: date }
    ) {
      edges {
        node {
          title
          slug
          content
        }
      }
    }
    categories: allWpCategory(
      sort: { order: ASC, fields: acfCategories___catCategoryOrder }
      filter: {
        language: { locale: { eq: $wpLocale } }
        acfCategories: { catShowOnGraphql: { eq: "1" } }
      }
    ) {
      edges {
        node {
          name
          slug
          acfCategories {
            catShowOnGraphql
            catCategoryIcon {
              localFile {
                publicURL
              }
            }
            catShowOnCountries
          }
          description
        }
      }
    }
    recommended: allWpSupportCenterItem(
      filter: {
        tags: { nodes: { elemMatch: { slug: { eq: "recommended" } } } }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
      }
      limit: 3
    ) {
      edges {
        node {
          slug
          title
          categories {
            nodes {
              slug
            }
          }
        }
      }
    }
  }
`;
